import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor } from "@joonapp/web-shared"
import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"

const MailAudioButton = ({ audioUrl }: { audioUrl: string }) => {
  const audioRef = useRef<HTMLAudioElement>(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const { t } = useTranslation()

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause()
      } else {
        audioRef.current.play()
      }
    }
  }

  return (
    <div className="flex flex-row w-[124px] h-[50px] items-center justify-center rounded-md border border-borderPrimary bg-backgroundPrimary p-2 gap-2">
      <button
        onClick={togglePlay}
        aria-label={isPlaying ? t("MAIL_PAUSE_AUDIO") : t("MAIL_PLAY_AUDIO")}
        className="flex items-center justify-center rounded-full w-8 h-8"
        style={{ backgroundColor: JoonUIColor.background.lightAccent }}
      >
        <FontAwesomeIcon
          icon={isPlaying ? faPause : faPlay}
          className={`w-4 h-4 ${isPlaying ? "" : "ml-[2px]"}`}
          color={JoonUIColor.icon.accent}
        />
      </button>
      <img src="/images/icons/soundwave.png" alt="Audio" className="h-8" />
      <audio
        ref={audioRef}
        src={audioUrl}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
        style={{ display: "none" }}
      >
        <track kind="captions" label="Audio caption" />
      </audio>
    </div>
  )
}

export default MailAudioButton
